import React, { CSSProperties } from 'react';

import styled from 'styled-components';

import {
  SkeletonAvatar,
  Skeleton,
  Title,
  Paragraph,
  Button,
  Icon,
  Tag,
  theme,
} from 'components';

export const Container = styled.div`
  width: 100%;
  padding: 5px 15px 24px 15px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  width: 100%;
`;

export const EmployerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const NameContainer = styled.div`
  margin: 10px 0px 7px 0px;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const FullProfileName = styled(Title)`
  &&& {
    color: ${theme.gray9};
    margin-bottom: 0px;
    text-align: center;
    width: 100%;
    overflow-wrap: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const PronounText = styled(Paragraph)`
  &&& {
    color: ${theme.textColorSecondary};
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
    text-align: center;
  }
`;

export const RolesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 2.5px 0px;
  width: 100%;
`;

export const CompanyText = styled(Paragraph)`
  &&& {
    color: ${theme.gray7};
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 0px;
  }
`;

export const TeamText = styled(Paragraph)`
  &&& {
    color: ${theme.gray8};
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 0px;
  }
`;

export const ChatButton = styled(Button)``;

export const ChatIcon = styled(Icon)``;

export const RoleTag = styled(Tag)`
  color: ${theme.blueBase};
  text-transform: capitalize;
  margin-bottom: 5px;
`;

const centerStyle = {
  display: 'flex',
  flexWrap: 'wrap' as CSSProperties['flexWrap'],
  justifyContent: 'center',
};

export const ProfileSkeleton = (
  <Container>
    <InfoContainer>
      <SkeletonAvatar size="large" />
      <NameContainer>
        <Skeleton
          title={{
            style: {
              margin: 'auto',
            },
            width: '90%',
          }}
          paragraph={{
            style: {
              ...centerStyle,
              marginTop: 18,
            },
            rows: 1,
            width: '90%',
          }}
        />
      </NameContainer>
      <RolesContainer>
        <Skeleton
          title={false}
          paragraph={{
            style: {
              ...centerStyle,
            },
            rows: 1,
            width: '90%',
          }}
        />
      </RolesContainer>
      <EmployerContainer>
        <Skeleton
          title={false}
          paragraph={{
            style: {
              ...centerStyle,
            },
            rows: 2,
            width: ['90%', '90%'],
          }}
        />
      </EmployerContainer>
    </InfoContainer>
  </Container>
);
